import { c as _c } from "react/compiler-runtime";
import { Button, Flex, Text } from '@endurancewarranty/ui';
import type { FC } from 'react';
type Props = {
  onClose: () => void;
};
export const SaveInProgressContent: FC<Props> = t0 => {
  const $ = _c(3);
  const {
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Text.Body size="md">A save is in progress. Please wait for the save to complete before continuing.</Text.Body>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClose) {
    t2 = <Flex direction="col" className="box-border h-[115px] overflow-y-auto" justify="between">{t1}<Flex className="mt-4" justify="end"><Button name="close-save-in-progress-modal" onClick={onClose} variant="secondary" margin="mr-2">Close</Button></Flex></Flex>;
    $[1] = onClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};